import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";

//interfaces
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { IUser } from "src/app/models/Identity/user";
import { UsersService } from "src/app/manage-users/services/user-services/users.service";
import { roleIdByName } from "src/app/auth/constants/auth.constants";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import {
  IQRCompartido,
  IQRCompartidoUser,
} from "src/app/misQr/interfaces/share-qr.interface";

// Intefaces
import { ModalSharedServiceService } from "src/app/shared/modals/modal-service.service";
import { Observable } from "rxjs";

// Services
import { ShareQrServiceService } from "src/app/misQr/services/share-qr.service.service";

@Component({
  selector: "app-modal-share-qr-card",
  templateUrl: "./modal-share-qr-card.component.html",
  styleUrls: ["./modal-share-qr-card.component.css"],
})
export class ModalShareQRCardComponent implements OnInit {
  @Input() data!: ICourseSession;
  title = "";

  public isLoading: boolean = false;
  public currentOwner: IUser | null = null;
  public userList: IUser[] | null = null;
  public userLogged: IUser | null = null;
  private userRole: roleIdByName | null = null;
  public QRCompartido: IQRCompartido | null = null;
  public sharedQRList: IQRCompartido[] | null = null;
  public sharedQRListName: IQRCompartidoUser[] | null = null;
  private readonly createQRURL = `${environment.apiUrlCap}/api/QrCompartido`;
  private readonly QRCompartidoURL = `${environment.apiUrlCap}/api/QrCompartido`;
  private readonly deleteQRURI = `${environment.apiUrlCap}/api/QrCompartido/`;
  public currentUser: IUser | null = null;

  @Output()
  closeModalEmitter = new EventEmitter<boolean>();

  constructor(
    private _authInternal: AuthenticationService,
    private _userService: UsersService,
    private _sharedModalService: ModalSharedServiceService,
    private httpClient: HttpClient,
    private shareQRService: ShareQrServiceService
  ) {}

  ngOnInit() {
    // User logged
    this.userLogged = this._authInternal.currentUserValue;

    // Get users list
    this._userService.getUsers().subscribe(users => {
      this.userList = users.filter(usr => usr.status == 1);
      this.loadShareQRDetails();
    });
  }

  closeModal() {
    this.closeModalEmitter.emit(true);
  }

  async createShareQR(selectedUser: IUser | null) {
    if (selectedUser == null || selectedUser === undefined) {
      return;
    }

    // Confirm Modal
    const confirmCreate = await this._sharedModalService.openModal(
      "confirm-modal",
      {
        title: "Se necesita confirmación",
        body:
          "¿Deseas compartir el QR de la sesión " +
          this.data.IdLocalizador +
          " - " +
          this.data.titulo +
          " con " +
          selectedUser?.name +
          "?",
      }
    );
    if (!confirmCreate) {
      return;
    }

    // Crear el objeto de compartición
    this.QRCompartido = {
      fkIdSesion: this.data.Id,
      usuarioDestino: selectedUser ? selectedUser.id : 0,
      usuarioOrigen: this.userLogged ? this.userLogged.id : 0,
      idLocalizador: this.data.IdLocalizador,
      fechaAlta: new Date(),
    };

    this.isLoading = true;
    const createObject: Observable<Object> = this.createItem(this.QRCompartido);
    createObject.subscribe({
      next: () => {
        this._sharedModalService.openModal("success-modal", {
          title: "¡Éxito!",
          body: "El QR ha sido compartido con el usuario.",
        });
        this.loadShareQRDetails();
      },
      error: err => {
        const personalizedError = err.error as ResponseDataInterfaces<null>;
        let msg = `Error al procesar la solicitud, Inténtalo mas tarde.`;
        this.isLoading = false;
        if (
          err.status === 422 &&
          Number(personalizedError.statusCode) === 422
        ) {
          msg = personalizedError.message;
        }

        this._sharedModalService.openModal("error-modal", {
          title: "¡Error!",
          body: msg,
        });
      },
    });
  }

  // create Item
  private createItem(QRShared: IQRCompartido) {
    const url = this.createQRURL + "/Guardar";
    const payload = QRShared;

    return this.httpClient.post(url, payload);
  }

  // Load Share QR Details
  public loadShareQRDetails() {
    this.currentUser = null;

    const userID = this.userLogged?.id ?? 0;
    // TODO: fix types
    const QR_Response: Observable<Object> = this.getQRList(
      this.data.IdLocalizador,
      userID
    );

    QR_Response.subscribe({
      next: response => {
        const resp = response as IQRCompartido[];
        this.sharedQRList = resp;
        this.sharedQRListName = this.setFullName(this.sharedQRList);
        this.isLoading = false;
      },
      error: err => {
        console.log(err);
        const personalizedError = err.error as ResponseDataInterfaces<null>;
        let msg = `Error al procesar la solicitud, Inténtalo mas tarde.`;
        if (
          err.status === 422 &&
          Number(personalizedError.statusCode) === 422
        ) {
          msg = personalizedError.message;
        }
        this._sharedModalService.openModal("error-modal", {
          title: "¡Error!",
          body: msg,
        });

        this.isLoading = false;
      },
    });
  }

  // get QR List
  getQRList(idLocalizador: number, userId: number) {
    const url =
      this.QRCompartidoURL +
      "?usuarioOrigen=" +
      userId.toString() +
      "&idLocalizador=" +
      idLocalizador.toString();
    const params = new HttpParams();
    params.append("usuarioOrigen", userId);
    params.append("idLocalizador", idLocalizador);
    return this.httpClient.get(url, { params });
  }

  public setFullName(_QRs: IQRCompartido[]) {
    var shareQRUsers: IQRCompartidoUser[] | null = null;

    for (let i = 0; i < _QRs.length; i++) {
      const qr = _QRs[i];
      const usrDestino =
        this.userList?.find(usr => usr.id === qr.usuarioDestino)?.name ??
        "Desconocido";
      const usrOrigen =
        this.userList?.find(usr => usr.id === qr.usuarioOrigen)?.name ??
        "Desconocido";
      if (shareQRUsers == null) {
        shareQRUsers = [];
      }
      shareQRUsers.push({
        idQRCompartido: qr.idQRCompartido,
        fkIdSesion: qr.fkIdSesion,
        usuarioDestino: qr.usuarioDestino,
        usrDestino: usrDestino,
        usuarioOrigen: qr.usuarioOrigen,
        usrOrigen: usrOrigen,
        idLocalizador: qr.idLocalizador,
        fechaAlta: qr.fechaAlta,
      });
    }

    return shareQRUsers;
  }

  async deleteQRCompartido(qr: IQRCompartido) {
    // Confirm Modal
    const confirmDelete = await this._sharedModalService.openModal(
      "confirm-modal",
      {
        title: "Se necesita confirmación",
        body: "¿Está seguro de que desea eliminar este QR compartido? ",
      }
    );
    if (!confirmDelete) {
      return;
    }

    const deleteQRObs: Observable<Object> = this.deleteQRID(qr.idQRCompartido);

    deleteQRObs.subscribe({
      next: () => {
        this._sharedModalService.openModal("success-modal", {
          title: "¡Éxito!",
          body: "El QR compartido ha sido eliminado correctamente.",
        });
        this.loadShareQRDetails();
      },
      error: err => {
        console.log(err);

        const personalizedError = err.error as ResponseDataInterfaces<null>;
        let msg = `Error al procesar la solicitud, Inténtalo mas tarde.`;

        if (
          err.status === 422 &&
          Number(personalizedError.statusCode) === 422
        ) {
          msg = personalizedError.message;
        }

        this._sharedModalService.openModal("error-modal", {
          title: "¡Error!",
          body: msg,
        });
      },
    });
  }

  deleteQRID(idQR?: number) {
    var response = this.httpClient.delete(this.deleteQRURI + idQR);
    return response;
  }
}
